export enum BreOrderType {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'commercial',
  RENTAL = 'rental',
  LONG_TERM = 'long_term',
  PROPERTY_MKTG = 'property_marketing',
  AGENT_MKTG = 'agent_marketing',
}
